






import React from "react";
import { Link } from "react-router-dom";
import "../styles/MultiPurposeVessels.css";
import "../pdf/Fleet_List-Multi.pdf";

// Import your icon and image
import mpvIcon from "../assets/icons/mpv-icon.png";
import mpvImage from "../image/MultiPurposeVessels-image.png";

const MultiPurposeVessels = () => {
  return (
    <div className="mpv-container">
    
      
    </div>
  );
};

export default MultiPurposeVessels;